export default __webpack_public_path__ + "static/media/subscript.18719473.svg";